import { createSlice, } from "@reduxjs/toolkit";
import { assign, pick } from "lodash";

const initialState = {
    warehouse: '',
}

const saveToLocalStorage = (state) => {
    localStorage.setItem("customizations", JSON.stringify(state))
}

const customizationsSlice = createSlice({
    name: "customizations",
    initialState,
    reducers: {
        setCustomizationsState: (state, action) => {
            assign(state, action.payload)
        },
        setWarehouse: (state, action) => {
            let value = action.payload
            if (!!value) {
                value = pick(value, ["id", "name"])
            }
            state.warehouse = value
            saveToLocalStorage(state)
        }
    }
})

export const { setCustomizationsState, setWarehouse } = customizationsSlice.actions

export default customizationsSlice.reducer
